export default __webpack_public_path__ + "static/media/delegates__cards-list-item-icon-6.994f5c7d.svg";